import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../../hooks/redux';
import { setProviderDeclarationChecked } from '../../../../store/slices/stepperSlice';
import CheckboxItem from '../../../ui/Checkbox/Checkbox';
import { Divider } from '../../../ui/Divider/Divider';
import { ProviderDeclarationProps } from './ProviderDeclaration.types';

export function ProviderDeclaration({
  componentInfo
}: ProviderDeclarationProps) {
  const dispatch = useDispatch();
  const { providerDeclarationChecked } = useAppSelector(
    (state) => state.stepper,
  );
  const { isEditingQuestionnaireItem } = useAppSelector(
    (state) => state.aiPowered
  );
  const hasInitialized = useRef(false);
  const initializationValue = useRef<boolean | undefined>(undefined);

  useEffect(() => {
    if (!hasInitialized.current && componentInfo.checked !== undefined) {
      initializationValue.current = componentInfo.checked;
      dispatch(setProviderDeclarationChecked(componentInfo.checked));
      hasInitialized.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isChecked = componentInfo.checked ?? providerDeclarationChecked;

  const handleCheck = () => {
    const newValue = !isChecked;
    dispatch(setProviderDeclarationChecked(newValue));
    if (componentInfo.onCheckedChange) {
      componentInfo.onCheckedChange(newValue);
    }
  };

  return (
    <div className="flex flex-col border border-gray-100 rounded-lg p-4">
      <h2 className="text-base text-gray-900v2 font-medium text-left">
        {componentInfo.title}
      </h2>
      <Divider classes="my-[14px]" />
      <div className="flex flex-col gap-4">
        <div className="p-6 bg-blue-50 rounded-md">
          <CheckboxItem
            onChange={handleCheck}
            checked={isChecked}
            value=""
            label={componentInfo.checkboxText}
            disabled={isEditingQuestionnaireItem}
            labelClasses="flex items-top gap-2 cursor-pointer"
            wrapperClasses="relative pt-1"
            textClasses="text-left !font-medium text-purple-900"
          />
        </div>
        {componentInfo.signedBy && (
          <div className="flex flex-col gap-2 items-start">
            <span className="text-xs text-red-550 font-medium uppercase text-nowrap tracking-wider">
              Signed by:
            </span>
            <span className="text-base font-medium text-gray-900">
              {componentInfo.signedBy}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
